import { USER_ROLE_TOOLS } from './models/UserRoles';
export var canEditOrOwn = function (store, record) {
    return (((record.createdBy && record.createdBy._id) || record.createdBy) === store.accountStore.currentUser._id ||
        store.accountStore.currentUser.rolesV1.find(function (e) { var _a; return (_a = e.tools.general) === null || _a === void 0 ? void 0 : _a.includes(USER_ROLE_TOOLS.GENERAL_can_edit_company_data); }));
};
